import { LogLevel } from "@azure/msal-browser";

export const configuration = {
    auth: {
      clientId: '',
      authority: '',
      audience: '',
      redirectUri:'/signin-oidc',
      postLogoutRedirectURi: '/',
      clientSecret: '',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
          // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
          loggerCallback: (level: any, message: any, containsPii: any) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.info(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
              case LogLevel.Warning:
                console.warn(message);
                return;
            }
          },
        }
    }
};


export const protectedResources = {
        scopes: {
            read: ['openid', 'profile', 'offline_access'],
        },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'offline_access', 'User.Read', 'Contacts.Read'],
};